export default "__VITE_ASSET__DZAAZT$G__"